export const appVersion = `1.3.4`
